import { Receiver } from 'player.js'
import { Howl } from 'howler'

const playerJs = new Receiver()

const playEl = document.getElementById('player');
["timer", "duration", "playBtn", "pauseBtn", "playbackSpeed", "progressBar", "progress"].forEach(id => {
    window[id] = document.getElementById(id);
});

class Player {
    constructor() {
        this.howl = null
        this.speed = 1
    }
    init(options) {
        if (this.howl) {
            this.howl.unload()
        }

        this.howl = new Howl({
            src: [options.url],
            html5: true,
            onplay: () => {
                requestAnimationFrame(this.step.bind(this))
                pauseBtn.style.display = null
                playBtn.style.display = "none"
            },
            onload: () => {
                if (duration) {
                    duration.innerHTML = this.formatTime(Math.round(this.howl.duration()))
                }
            },
            onend: () => {
                this.reset()
            },
            onpause: () => {
            },
            onstop: () => {
            },
            onseek: () => {
            },
            onrate: () => {
            }
        })
    }
    play() {
        if (! this.howl.playing()) {
            this.howl.play()
            playBtn.style.display = "none"
            pauseBtn.style.display = null
        }
    }
    reset() {
        if (duration) {
            duration.innerHTML = this.formatTime(0)
        }
        if (timer) {
            timer.innerHTML = this.formatTime(0)
        }
        playBtn.style.display = null
        pauseBtn.style.display = "none"
    }
    pause() {
        this.howl.pause()
        playBtn.style.display = null
        pauseBtn.style.display = "none"
    }
    seek(p) {
        if (this.howl.playing()) {
            this.howl.seek(this.howl.duration() * p)
            this.howl.pause()
            this.howl.play()
        }
    }
    seekBySeconds(seconds) {
        this.navigateTo(this.howl.seek() + seconds)
    }
    navigateTo(second) {
        if (this.howl.playing()) {
            this.howl.seek(second)
        }
    }
    setVolume(volume) {
        this.howl.volume(volume / 100)
    }
    step() {
        var left = this.howl.seek() || 0

        if (timer) {
            timer.innerHTML = this.formatTime(Math.round(left))
        }
        if (progress) {
            progress.style.transform = `translate(${(left / this.howl.duration() * 100 || 100)}%, 0)`
        }
        if (this.howl.playing()) {
            requestAnimationFrame(this.step.bind(this))
        }
    }
    toggleSpeed() {
        this.speed = 2 == this.speed ? .5 : this.speed + .25
        this.howl.rate(this.speed)

        playbackSpeed.innerHTML = this.speed + "x"
    }
    formatTime(sec) {
        var minutes = Math.floor(sec / 60) || 0
        var aByte = sec - 60 * minutes || 0

        return (minutes < 10 ? "0" : "") + minutes + ":" + (aByte < 10 ? "0" : "") + aByte
    }
}

class PlayerEmbedlyAdapter {
    constructor() {
        this.init()
    }
    init() {
        this.setupListeners()
        this.setupActions()
    }
    setupListeners() {
        player.howl.on('play', () => {
            playerJs.emit('play')
        })
        player.howl.on('pause', () => {
            playerJs.emit('pause')
        })
        player.howl.on('end', () => {
            playerJs.emit('ended')
        })
        setInterval(() => {
            if (player.howl.playing()) {
                playerJs.emit('timeupdate', {
                    seconds: Math.round(player.howl.seek())
                });
            }
        }, 100);
        player.howl.on('load', () => {
            playerJs.ready()
        })
    }
    setupActions() {
        playerJs.on('play', () => {
            player.play();
        });
        playerJs.on('pause', () => {
            player.pause();
        });
        playerJs.on('getPaused', callback => {
            callback(!player.howl.playing());
        });
        playerJs.on('getCurrentTime', callback => {
            callback(player.howl.seek());
        });

        playerJs.on('setCurrentTime', value => {
            player.navigateTo(value);
        });

        playerJs.on('getDuration', callback => {
            callback(player.howl.duration());
        });
        playerJs.on('setVolume', value => {
            player.setVolume(value);
        });
        playerJs.on('getVolume', callback => {
            callback(player.howl.volume() * 100);
        });
        playerJs.on('mute', value => {
            player.howl.mute(true);
        });
        playerJs.on('unmute', callback => {
            player.howl.mute(false);
        });
        playerJs.on('getMuted', callback => {
            callback(player.howl.mute());
        });
        playerJs.on('getLoop', callback => {
            callback(player.howl.loop());
        });
        playerJs.on('setLoop', value => {
            player.howl.loop(value);
        });
    }
}

const player = new Player

player.init({
    url: playEl.dataset.url
})

new PlayerEmbedlyAdapter()

playBtn.addEventListener('click', () => {
    player.play();
});

pauseBtn.addEventListener('click', () => {
    player.pause();
});

if (progressBar) {
    progressBar.addEventListener('click', function (event) {
        var left = this.offsetLeft;
        var n = this;
        for (; n.offsetParent && (left = left + n.offsetParent.offsetLeft, n != document.getElementsByTagName("body")[0]);) {
            n = n.offsetParent;
        }
        player.seek((event.clientX - left) / this.offsetWidth);
    });
}

if (playbackSpeed) {
    playbackSpeed.addEventListener('click', () => {
        player.toggleSpeed();
    });    
}
